import { VisuallyHidden } from '@reach/visually-hidden'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import {
  hasEmptyCartSelector,
  miniCartItemsCountTextSelector
} from '@/selectors'

const Header = ({ onDismiss }) => {
  const cartItemCountText = useSelector(miniCartItemsCountTextSelector)
  const hasEmptyCart = useSelector(hasEmptyCartSelector)

  return (
    <div className={`header ${hasEmptyCart && 'empty-cart'}`}>
      <If condition={!hasEmptyCart}>
        <p id='mini-cart-heading' tabIndex='-1'>
          {cartItemCountText}
        </p>
      </If>
      <button
        className='vst-btn--transparent mini-cart__button-close'
        onClick={onDismiss}
      >
        <VisuallyHidden>{'Close Dialog'}</VisuallyHidden>
        <img alt='' src={require(`/app/assets/images/close-icon-black.svg`)} />
      </button>
    </div>
  )
}

export default Header

Header.propTypes = {
  onDismiss: PropTypes.func.isRequired,
}
